import React from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';
import { Link } from 'react-router-dom';

const VesselTypeProductVariantListCard = ({ className, variants }) => (
  <Card className={cn(className, 'pa3')}>
    <div>
      <h3 className="f4 mt0">Products variants that use this vessel type</h3>
      {!variants.length && <p>No product variants use this vessel type.</p>}
      {variants.map(variant => (
        <h4 className="f5">
          {variant.name}
          <em>
            <Link to={`/products/${variant.product.id}`}> - {variant.product.name}</Link>
          </em>
        </h4>
      ))}
    </div>
  </Card>
);

export default VesselTypeProductVariantListCard;



// WEBPACK FOOTER //
// ./src/components/vesselTypeProductVariantListCard/vesselTypeProductVariantListCard.jsx